import React, { useEffect, useState } from "react";

import { Form } from "antd";
import { createUseStyles } from "react-jss";
import { CloseOutlined } from "@ant-design/icons";
import { faBuildingUser } from "@fortawesome/pro-duotone-svg-icons";

import Icon from "../../Icon";
import UIFormNew from "./UIFormNew";

const UIMultiFields = ({
  label,
  name,
  required,
  rules,
  onChange,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  defaultValue,
  placeholder = "",
  option = [],
  mode,
  fields,
  colon,
  showTitle = true,
  showForm = false,
  showAdd = true,
}) => {
  const [showFormValues, setShowFormValues] = useState(showForm)
  const [formFields, setFormFields] = useState(
    defaultValue.length > 0 ? [] : [fields]
  );

  const styles = useStyle();

  useEffect(() => {
    if (defaultValue.length > 0) {
      getDefaultFields();
    }
  }, []);

  const getDefaultFields = () => {
    let newFields = [];
    defaultValue.map((value, index) => {
      let Fields = [];

      fields.map((item, ind) => {
        Fields.push({
          ...item,
          Fields: item.Fields.map((fieldItem, i) => {
            if (fieldItem?.FieldType === "Editor") {
              onChange({
                [`${fieldItem?.ObjectId}${index + 1}`]: value[
                  fieldItem?.ObjectId
                ]
                  ? atob(value[fieldItem?.ObjectId])
                  : "",
              });
            } else {
              onChange({
                [`${fieldItem?.ObjectId}${index + 1}`]:
                  value[fieldItem?.ObjectId],
              });
            }
            return {
              ...fieldItem,
              DefaultValue: value[fieldItem?.ObjectId],
            };
          }),
        });
      });
      newFields.push(Fields);
    });
    setFormFields(newFields);
  };

  const onSwitch = (state, targetId, index) => {
    let newFields = [...formFields];
    newFields[index] = newFields[index].map((item, ind) => {
      return {
        ...item,
        Fields: item.Fields.map((val, ind) => {
          if (targetId === val?.ObjectId) {
            return {
              ...val,
              Disabled: state,
            };
          } else {
            return val;
          }
        }),
      };
    });

    setFormFields(newFields);
  };

  const onAdd = () => {
    if (!showFormValues) {
      setShowFormValues(true)
    } else {
      setFormFields([...formFields, fields]);
    }
  };

  const onRemove = (index) => setFormFields(formFields.filter((__, idx) => idx != index));

  return (
    <Form.Item
      label={showTitle && label}
      name={name}
      required={required}
      rules={rules}
      colon={colon}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={defaultValue?.toString()}
    >
      {showFormValues && formFields.map(
        (item, index) =>
          item && (
            <div className={styles.item}>
              <div className={styles.itemIcon}>
                <Icon size={35} Icon={faBuildingUser} />
              </div>
              <div key={index} className={styles.form}>
                <CloseOutlined
                  onClick={() => onRemove(index)}
                  style={{
                    alignSelf: "flex-end",
                  }}
                />
                <UIFormNew
                  fields={item}
                  requiredMark={false}
                  size="large"
                  hideMultiFields={true}
                  onSwitch={(e, targetId) => onSwitch(e, targetId, index)}
                  onChange={(e) => {
                    onChange({
                      [`${e?.target?.id}${index + 1}`]: e?.target?.value,
                    });
                  }}
                />
              </div>
            </div>
          )
      )}{
        showAdd &&
        <div className={styles.addBtn} onClick={onAdd}>
          + Add
        </div>
      }
    </Form.Item>
  );
};

const useStyle = createUseStyles({
  item: {
    display: "flex",
    marginBottom: 10,
  },
  itemIcon: {
    background: "#f7f7f7",
    borderColor: "#EEE",
    borderWidth: 1,
    borderStyle: "double",
    marginRight: 15,
    padding: 20,
    height: 85,
    borderRadius: 50,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  form: {
    background: "#f7f7f7",
    padding: 25,
    borderRadius: 20,
    borderColor: "#EEE",
    borderWidth: 1,
    borderStyle: "double",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  addBtn: {
    padding: 10,
    background: "#f7f7f7",
    alignSelf: "flex-end",
    width: 100,
    textAlign: "center",
    borderRadius: 20,
    cursor: "pointer",
  },
});

export default UIMultiFields;
